import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/providers/common.service';

@Component({
  selector: 'app-not-transact-tpnlistv2',
  templateUrl: './not-transact-tpnlistv2.component.html',
  styleUrls: ['./not-transact-tpnlistv2.component.scss']
})
export class NotTransactTpnlistv2Component implements OnInit {

  constructor(public modal: NgbActiveModal, private ngbModal:NgbModal,private commonService: CommonService) { }
  NTTPNList:any;
  customDays: any;
  @Input() NTTPNResult :any;
  @Input() customNTTPNDays :any;
  buttonLoader: any= false;

  ngOnInit(): void {
    //console.log("this.NTTPNResult $$$$  ===> ", this.NTTPNResult);
    this.NTTPNList = this.NTTPNResult;
    this.customDays = this.customNTTPNDays;
  }

  downloadData(){
    this.buttonLoader = true;
    let fileName = "NotTransactTPNList.xlsx";
    let worksheetData = {
      "worksheet" : [
        {
          "name": 'Not Transact TPN List',
          "columns":  [
            { header: "TPN", key: "tpn", width: 16 },
            // { header: "TPN-DefaulLabel", key: "defaultLabel", width: 20 },
            { header: "TPN-SerialNumber", key: "serialNumber", width: 20 },
            { header: "Merchant DBA", key: "merchantdba", width: 20 },
            { header: "Store DBA", key: "storedba", width: 20 },
            { header: "Created On", key: "createdOn", width: 20},
            { header: "MCC Code", key: "merchantCategoryCode", width: 8},
            { header: "Device Model", key: "deviceModelId", width: 20},
            // { header: "Last Transaction Date", key: "lastTxDate", width: 20},
            { header: "Merchant Mobile", key: "phoneNumber", width: 15},
            { header: "Merchant Email", key: "email", width: 20},
          ],
          "rows": this.NTTPNResult,
          "isRow": 0,
          frozen:true,
        }
      ],
      "fileName": fileName
    };

    this.commonService.downloadAsExcel(worksheetData).then(res => {
      // this.modalReference.close();
      this.buttonLoader = false;
    });
  }

}
